// extracted by mini-css-extract-plugin
module.exports = {"roundedAnchor":"Anchors_roundedAnchor__EnqI6"};